var _path, _path2, _circle, _path3, _path4, _circle2, _circle3, _circle4, _g, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 140,
    viewBox: "0 0 122 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 60L115.592 69.6872L117.896 80.8397L109.071 87.8802L107.463 99.1571L96.8001 102.714L91.5055 112.762L80.2882 112.409L71.9186 120L61.5003 115.756L51.0814 120L42.7118 112.409L31.4938 112.762L26.1999 102.714L15.5365 99.1571L13.9293 87.8795L5.1036 80.8397L7.40754 69.6872L1.5 60L7.40754 50.3121L5.1036 39.1597L13.9293 32.1198L15.5371 20.8423L26.1999 17.2856L31.4944 7.23784L42.7118 7.59125L51.0814 0L61.5003 4.24352L71.9186 0L80.2882 7.59125L91.5062 7.23784L96.8001 17.2862L107.464 20.8429L109.071 32.1198L117.896 39.1603L115.592 50.3121L121.5 60Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4941 108.914C88.0998 108.914 109.668 87.0168 109.668 60.0052C109.668 32.9937 88.0998 11.0964 61.4941 11.0964C34.8885 11.0964 13.3203 32.9937 13.3203 60.0052C13.3203 87.0168 34.8885 108.914 61.4941 108.914Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5991,
    cy: 60.0051,
    r: 32.1148,
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8555 31.8328C75.739 33.247 79.2472 35.4415 82.1914 38.2263L32.4355 66.9529C31.9063 64.7231 31.625 62.3972 31.625 60.0056C31.625 58.2301 31.7791 56.4902 32.0752 54.7996L71.8555 31.8328Z",
    fill: "#676767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4229 43.2009C89.6738 47.9938 91.5742 53.7779 91.5742 60.0056C91.5742 61.7807 91.418 63.5194 91.1221 65.2097L51.3418 88.1765C44.011 85.5064 38.0168 80.057 34.6328 73.1023L86.4229 43.2009Z",
    fill: "#676767"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5977,
    cy: 60.0052,
    r: 23.5508,
    fill: "#DFDFDF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5973,
    cy: 60.0051,
    r: 21.4098,
    fill: "#878787"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4263_23484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 38,
    width: 44,
    height: 44
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5973,
    cy: 60.0051,
    r: 21.4098,
    fill: "#00A4B3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4263_23484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.908 95.8666L73.9057 57.3289L61.0598 60.0051L54.1016 71.2453L92.6393 109.783L111.908 95.8666Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.131 86.7674L61.5938 48.2297V60.0051L100.131 98.5429V86.7674Z",
    fill: "#DFDFDF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 48.2297L65.3753 55.8794L73.9106 57.3289L67.7086 63.0604L69.0934 71.2453L61.6 67.4986L54.1065 71.2453L55.4914 63.0604L49.3828 57.106L57.8247 55.8794L61.6 48.2297Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5859 30.9182C95.3604 38.1096 100.24 48.4721 100.24 59.9915C100.24 66.7985 98.5359 73.2012 95.5376 78.7849",
    stroke: "#2D3962",
    strokeWidth: 3.34997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7161 30.9182C26.9416 38.1096 22.0625 48.4721 22.0625 59.9915C22.0625 66.7985 23.7662 73.2012 26.7644 78.7849",
    stroke: "#2D3962",
    strokeWidth: 3.34997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeEmptyState);
export default __webpack_public_path__ + "static/media/badge-empty-state.25ca1971dc27f1e8d9e9f9ee1bd20068.svg";
export { ForwardRef as ReactComponent };